<template>
  <div class="new-box">
    <div class="section-title">
      <img class="" src="../assets/images/news-title.png" alt="" />
    </div>
    <div class="news-main">
      <ul class="nav">
        <li v-for="(i, index) in types" :key="index + 1" class="hvrradialin"  @click="num = index;newnum = 0"  :class="{ hvrradialout: num == index }" >
          {{ i.title }}
        </li>
      </ul>
      <div v-for="(typeItem, index) in types" :key="index" v-show="num == index" >
        <div class="new-top">
          <div class="newlist"  v-for="(item, index) in (list.filter(m=>m.IndustryType == typeItem.id))" :key="index" v-show="newnum == index">
            <img class="newimg animate__animated animate__fadeIn" :src="item.ImageUrl" alt="" />
            <div class="newright animate__animated animate__fadeInRight">
              <h2 class="newtitle">{{ item.Title }}</h2>          
              <p class="newcontent">{{ item.Text }}</p>
              <div class="new-not-bottom">
                <div class="new-not-bottom-left"><span class="newtime">{{ item.AddDateTime }}</span>
                <span class="iconfont icon-erweima" v-if="item.GzhUrl!=undefined && item.GzhUrl!=''"><div class="code-new"><img :src="item.GzhUrl" alt=""></div></span>
                </div>
              <div class="look-btn" @click="$router.push({path:'/newsdetail?id='+item.Id})">查看详情<span class="iconfont icon-jiantou1"></span></div>
              </div>
            </div>
          </div>
        </div>
        <swiper :options="galleryThumbs" ref="mySwiper" class="animate__animated animate__fadeIn">
          <swiper-slide v-for="(item, index) in (list.filter(m=>m.IndustryType == typeItem.id))" :key="index">
            <div
              class="newlist-small"
              @click="newnum = index"
              :class="{ activenewlist: newnum == index }"
            >
              <img class="newimg" :src="item.ImageUrl" alt="" />
              <div class="newright">
                <h2 class="newtitle">{{ item.Title }}</h2>
                <p class="newtime">{{ item.AddDateTime }}</p>
              </div>
            </div>
          </swiper-slide>
        </swiper>
        <div v-show="(list.filter(m=>m.IndustryType == typeItem.id)).length>3" class="swiper-button-prev swiper-button-prev-new" slot="button-prev"></div>
            <div v-show="(list.filter(m=>m.IndustryType == typeItem.id)).length>3" class="swiper-button-next swiper-button-next-new" slot="button-next"></div>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  data () {
    return {
      num: 0,
      newnum: 0,
      types: [
        { title: "最新资讯", id: 0 },
        { title: "住房城乡建设行业", id: 1 },
        { title: "交通运输行业", id: 2 },
        { title: "食品安全行业", id: 3 },
        { title: "医疗卫生行业", id: 4 },
        { title: "其它行业", id: 5 },
      ],
      galleryThumbs: {
        spaceBetween: 10,
        slidesPerView: 3,
        freeMode: true,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        navigation: {
          nextEl: '.swiper-button-next-new',
          prevEl: '.swiper-button-prev-new'
        }
      },
      list:[]

    }
  },
  methods: {
    getList:function(){
      this.axios({
        method: "get",
        url: "/api/News/GetHomes",
        params: {},
      }).then((res) => {
        this.list = res.data.data
      });
    }
  },
  mounted:function(){
    this.getList();
  }
}
</script>
<style lang="less" scoped>
.swiper-button-next, .swiper-container-rtl .swiper-button-prev {
  height: 53px;
    width: 22px;
    top: 90%;
    right: -30px;
    background: url('../assets/images/right-icon.png') no-repeat;
    background-size: 100% 100%;
}
.swiper-button-prev, .swiper-container-rtl .swiper-button-next {
    height: 53px;
    width: 22px;
    top: 90%;
    left: -30px;
    background: url('../assets/images/left-icon.png') no-repeat;
    background-size: 100% 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/newView.vue